<aside class="options-open">
  <p style="padding: 10px 20px 0 30px">
    Configurable options available for the {{ activeField?.label }} field. Navigate elsewhere in the document to add more fields.
  </p>
  <div class="field-config scrollable-container">
    <header>
      <h2 class="title heading-underline">
        <span>{{ activeField?.label }} <span class="grey">options</span></span>
        <mat-icon (click)="closeOptions()" (keydown.space)="closeOptions()" title="Close field options" tabindex="0"> close </mat-icon>
      </h2>
    </header>

    <article id="popup-scroll" class="options-body scrollable-container">
      <!-- option config - required -->
      @if (showRequired) {
        <div>
          <mat-slide-toggle [(ngModel)]="isRequired" (change)="modified = true">Required for recipient?</mat-slide-toggle>
        </div>
      }

      <!-- option config - date validation -->
      @if (showDateValidation) {
        <div>
          <span class="option-title">
            <mat-icon fontIcon="edit_calendar" title="Custom date format"></mat-icon>
            <h3>Date Validation</h3>
          </span>
          <mat-select panelClass="docusign-options-mat-select" [(ngModel)]="dateValidation" (ngModelChange)="modified = true">
            @for (pattern of DocusignOptionsService.dateValidationPatterns; track pattern.validationType) {
              <mat-option
                [value]="pattern.validationType"
                title="Add date validation to the Date Entry"
                >
                {{ pattern.label }}
              </mat-option>
            }
          </mat-select>
        </div>
      }

      <!-- option config - tooltip -->
      @if (showToolTip) {
        <div>
          <span class="option-title">
            <mat-icon fontIcon="textsms" title="Tooltip text"></mat-icon>
            <h3>Tooltip</h3>
          </span>
          <small>Text displayed when the user hovers over the tag</small>
          <input placeholder="Tooltip text" title="This is a tooltip" [(ngModel)]="toolTip" (ngModelChange)="modified = true" />
        </div>
      }

      <!-- option config - value -->
      @if (showTabValue) {
        <div>
          <span class="option-title">
            <mat-icon fontIcon="edit" title="Tooltip text">edit</mat-icon>
            <h3>Button Value</h3>
          </span>
          <input placeholder="Radio button value" title="Radio button value" [(ngModel)]="tabValue" (ngModelChange)="modified = true" />
        </div>
      }

      <!-- option config - URL -->
      @if (showUrlEntry) {
        <div>
          <span class="option-title">
            <mat-icon fontIcon="link" title="Link to website or resource"></mat-icon>
            <h3>URL</h3>
          </span>
          <input placeholder="Link to website or resource" [(ngModel)]="urlValue" (ngModelChange)="modified = true" />
          <span class="option-title">
            <mat-icon fontIcon="abc" title="Text shown to user in place of the web address URL"></mat-icon>
            <h3 title="Text shown to user in place of the web address URL">URL Display Text</h3>
          </span>
          <input
            title="Text shown to user in place of the web address URL"
            placeholder="Leave blank to show URL"
            [(ngModel)]="urlDisplayText"
            (ngModelChange)="modified = true"
            />
          </div>
        }
      </article>
    </div>
    @if (activeField) {
      <button
        (click)="onUpdateClick()"
        [ngClass]="{ 'needs-saving': modified }"
        [disabled]="!modified"
        theme="medium"
        class="insert-update-field"
        title="Update current field in Document"
        >
        <mat-icon fontIcon="arrow_back_ios_new"></mat-icon>
        UPDATE FIELD
      </button>
    }
  </aside>
